module.exports = __webpack_public_path__ + "static/media/KTM.f0e17963.svg";